var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg13D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6067 22.527C15.6257 22.3362 15.9038 22.3362 15.9228 22.527V22.527C15.9336 22.6351 16.0473 22.7007 16.1463 22.656V22.656C16.321 22.5771 16.4601 22.8179 16.3043 22.9298V22.9298C16.2161 22.9932 16.2161 23.1245 16.3043 23.1878V23.1878C16.4601 23.2997 16.321 23.5405 16.1463 23.4616V23.4616C16.0473 23.4169 15.9336 23.4825 15.9228 23.5906V23.5906C15.9038 23.7814 15.6257 23.7814 15.6067 23.5906V23.5906C15.5959 23.4825 15.4822 23.4169 15.3832 23.4616V23.4616C15.2085 23.5405 15.0694 23.2997 15.2251 23.1878V23.1878C15.3134 23.1245 15.3134 22.9932 15.2251 22.9298V22.9298C15.0694 22.8179 15.2085 22.5771 15.3832 22.656V22.656C15.4822 22.7007 15.5959 22.6351 15.6067 22.527V22.527Z",
    fill: "url(#paint0_linear_10214_613)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0773 22.527C20.0963 22.3362 20.3744 22.3362 20.3934 22.527V22.527C20.4042 22.6351 20.5178 22.7007 20.6168 22.656V22.656C20.7916 22.5771 20.9306 22.8179 20.7749 22.9298V22.9298C20.6867 22.9932 20.6867 23.1245 20.7749 23.1878V23.1878C20.9306 23.2997 20.7916 23.5405 20.6168 23.4616V23.4616C20.5178 23.4169 20.4042 23.4825 20.3934 23.5906V23.5906C20.3744 23.7814 20.0963 23.7814 20.0773 23.5906V23.5906C20.0665 23.4825 19.9528 23.4169 19.8538 23.4616V23.4616C19.6791 23.5405 19.54 23.2997 19.6957 23.1878V23.1878C19.784 23.1245 19.784 22.9932 19.6957 22.9298V22.9298C19.54 22.8179 19.6791 22.5771 19.8538 22.656V22.656C19.9528 22.7007 20.0665 22.6351 20.0773 22.527V22.527Z",
    fill: "url(#paint1_linear_10214_613)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8419 24.527C17.8609 24.3362 18.139 24.3362 18.158 24.527V24.527C18.1688 24.6351 18.2825 24.7007 18.3815 24.656V24.656C18.5562 24.5771 18.6953 24.8179 18.5396 24.9298V24.9298C18.4513 24.9932 18.4513 25.1245 18.5396 25.1878V25.1878C18.6953 25.2997 18.5562 25.5405 18.3815 25.4616V25.4616C18.2825 25.4169 18.1688 25.4825 18.158 25.5906V25.5906C18.139 25.7814 17.8609 25.7814 17.8419 25.5906V25.5906C17.8311 25.4825 17.7175 25.4169 17.6184 25.4616V25.4616C17.4437 25.5405 17.3047 25.2997 17.4604 25.1878V25.1878C17.5486 25.1245 17.5486 24.9932 17.4604 24.9298V24.9298C17.3047 24.8179 17.4437 24.5771 17.6184 24.656V24.656C17.7175 24.7007 17.8311 24.6351 17.8419 24.527V24.527Z",
    fill: "url(#paint2_linear_10214_613)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8419 20.4094C17.8609 20.2186 18.139 20.2186 18.158 20.4094V20.4094C18.1688 20.5175 18.2825 20.5831 18.3815 20.5384V20.5384C18.5562 20.4595 18.6953 20.7003 18.5396 20.8122V20.8122C18.4513 20.8755 18.4513 21.0068 18.5396 21.0702V21.0702C18.6953 21.1821 18.5562 21.4229 18.3815 21.344V21.344C18.2825 21.2993 18.1688 21.3649 18.158 21.473V21.473C18.139 21.6638 17.8609 21.6638 17.8419 21.473V21.473C17.8311 21.3649 17.7175 21.2993 17.6184 21.344V21.344C17.4437 21.4229 17.3047 21.1821 17.4604 21.0702V21.0702C17.5486 21.0068 17.5486 20.8755 17.4604 20.8122V20.8122C17.3047 20.7003 17.4437 20.4595 17.6184 20.5384V20.5384C17.7175 20.5831 17.8311 20.5175 17.8419 20.4094V20.4094Z",
    fill: "url(#paint3_linear_10214_613)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 24.527C22.3315 24.3362 22.6096 24.3362 22.6286 24.527V24.527C22.6394 24.6351 22.7531 24.7007 22.8521 24.656V24.656C23.0268 24.5771 23.1659 24.8179 23.0101 24.9298V24.9298C22.9219 24.9932 22.9219 25.1245 23.0101 25.1878V25.1878C23.1659 25.2997 23.0268 25.5405 22.8521 25.4616V25.4616C22.7531 25.4169 22.6394 25.4825 22.6286 25.5906V25.5906C22.6096 25.7814 22.3315 25.7814 22.3125 25.5906V25.5906C22.3017 25.4825 22.188 25.4169 22.089 25.4616V25.4616C21.9143 25.5405 21.7752 25.2997 21.931 25.1878V25.1878C22.0192 25.1245 22.0192 24.9932 21.931 24.9298V24.9298C21.7752 24.8179 21.9143 24.5771 22.089 24.656V24.656C22.188 24.7007 22.3017 24.6351 22.3125 24.527V24.527Z",
    fill: "url(#paint4_linear_10214_613)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 20.4094C22.3315 20.2186 22.6096 20.2186 22.6286 20.4094V20.4094C22.6394 20.5175 22.7531 20.5831 22.8521 20.5384V20.5384C23.0268 20.4595 23.1659 20.7003 23.0101 20.8122V20.8122C22.9219 20.8755 22.9219 21.0068 23.0101 21.0702V21.0702C23.1659 21.1821 23.0268 21.4229 22.8521 21.344V21.344C22.7531 21.2993 22.6394 21.3649 22.6286 21.473V21.473C22.6096 21.6638 22.3315 21.6638 22.3125 21.473V21.473C22.3017 21.3649 22.188 21.2993 22.089 21.344V21.344C21.9143 21.4229 21.7752 21.1821 21.931 21.0702V21.0702C22.0192 21.0068 22.0192 20.8755 21.931 20.8122V20.8122C21.7752 20.7003 21.9143 20.4595 22.089 20.5384V20.5384C22.188 20.5831 22.3017 20.5175 22.3125 20.4094V20.4094Z",
    fill: "url(#paint5_linear_10214_613)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3713 24.527C13.3903 24.3362 13.6684 24.3362 13.6875 24.527V24.527C13.6982 24.6351 13.8119 24.7007 13.9109 24.656V24.656C14.0857 24.5771 14.2247 24.8179 14.069 24.9298V24.9298C13.9808 24.9932 13.9808 25.1245 14.069 25.1878V25.1878C14.2247 25.2997 14.0857 25.5405 13.9109 25.4616V25.4616C13.8119 25.4169 13.6982 25.4825 13.6875 25.5906V25.5906C13.6684 25.7814 13.3903 25.7814 13.3713 25.5906V25.5906C13.3605 25.4825 13.2469 25.4169 13.1479 25.4616V25.4616C12.9731 25.5405 12.8341 25.2997 12.9898 25.1878V25.1878C13.078 25.1245 13.078 24.9932 12.9898 24.9298V24.9298C12.8341 24.8179 12.9731 24.5771 13.1479 24.656V24.656C13.2469 24.7007 13.3605 24.6351 13.3713 24.527V24.527Z",
    fill: "url(#paint6_linear_10214_613)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3713 20.4094C13.3903 20.2186 13.6684 20.2186 13.6875 20.4094V20.4094C13.6982 20.5175 13.8119 20.5831 13.9109 20.5384V20.5384C14.0857 20.4595 14.2247 20.7003 14.069 20.8122V20.8122C13.9808 20.8755 13.9808 21.0068 14.069 21.0702V21.0702C14.2247 21.1821 14.0857 21.4229 13.9109 21.344V21.344C13.8119 21.2993 13.6982 21.3649 13.6875 21.473V21.473C13.6684 21.6638 13.3903 21.6638 13.3713 21.473V21.473C13.3605 21.3649 13.2469 21.2993 13.1479 21.344V21.344C12.9731 21.4229 12.8341 21.1821 12.9898 21.0702V21.0702C13.078 21.0068 13.078 20.8755 12.9898 20.8122V20.8122C12.8341 20.7003 12.9731 20.4595 13.1479 20.5384V20.5384C13.2469 20.5831 13.3605 20.5175 13.3713 20.4094V20.4094Z",
    fill: "url(#paint7_linear_10214_613)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9962 22.555H10.186C7.60386 22.555 6.11768 20.9027 6.11768 18.8603C6.11768 17.0918 7.23854 15.6969 8.89909 15.2237C9.18969 11.9109 11.913 9.41176 15.1344 9.41176C17.6004 9.41176 19.6262 10.7485 20.7305 12.9404C23.7444 12.9404 25.9612 14.9995 25.9612 17.7311C25.9612 20.4378 23.7942 22.555 20.9962 22.555Z",
    fill: "#B9DDFF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3956 13.1091L20.4995 13.3154H20.7305C23.5674 13.3154 25.5862 15.2355 25.5862 17.7311C25.5862 20.2212 23.5967 22.18 20.9962 22.18H10.186C8.97676 22.18 8.05784 21.7947 7.44361 21.2034C6.82895 20.6117 6.49268 19.7885 6.49268 18.8603C6.49268 17.2674 7.49448 16.0139 9.00187 15.5843L9.2501 15.5136L9.27266 15.2564C9.54664 12.1331 12.1116 9.78676 15.1344 9.78676C17.4494 9.78676 19.3507 11.0352 20.3956 13.1091Z",
    stroke: "url(#paint8_linear_10214_613)",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_613",
    x: -13.8823,
    y: -10.5882,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_613"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_613",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_613",
    x1: 14.8688,
    y1: 21.8676,
    x2: 18.1185,
    y2: 22.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_613",
    x1: 19.3394,
    y1: 21.8676,
    x2: 22.5891,
    y2: 22.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10214_613",
    x1: 17.104,
    y1: 23.8676,
    x2: 20.3537,
    y2: 24.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10214_613",
    x1: 17.104,
    y1: 19.75,
    x2: 20.3537,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10214_613",
    x1: 21.5746,
    y1: 23.8676,
    x2: 24.8243,
    y2: 24.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10214_613",
    x1: 21.5746,
    y1: 19.75,
    x2: 24.8243,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10214_613",
    x1: 12.6335,
    y1: 23.8676,
    x2: 15.8832,
    y2: 24.9852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10214_613",
    x1: 12.6335,
    y1: 19.75,
    x2: 15.8832,
    y2: 20.8675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10214_613",
    x1: 6.11768,
    y1: 9.41176,
    x2: 26,
    y2: 22.5882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645504,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13D);
export default __webpack_public_path__ + "static/media/13d.ac0d4a95bdf0dce3af6db3987a7a9627.svg";
export { ForwardRef as ReactComponent };